module.exports = __webpack_public_path__ + "media/application/images/features/bundles-2200-60431ebb420be7c9d15f48ae3eac92d0.png";